import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class TablePhoneInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data?.length > 5 && (
                    <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{checkTranslation(this.props.data)}</p>
                )}
            </div>
        )
    }
}

export default TablePhoneInput;